// extracted by mini-css-extract-plugin
export default {"wrapper":"Stack_wrapper__OJjG1","logos":"Stack_logos__48dN+"};